import React from "react";
import { Button, Grid, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { getAppColor, getUserRole } from "@icarius-app/selectors";
import { getLocalizedString } from "@icarius-localization/strings";

const HeaderDataDisplay = ({ name, value }) => {
    return (
        <Grid container item direction="column" xs={12} sm={6} md={4}>
            <Typography className="whiteText">{name}:</Typography>
            <Typography className="whiteText" style={{ fontWeight: 600 }}>
                {value}
            </Typography>
        </Grid>
    );
};

const Row = ({ data, handleClick }) => {
    const color = useSelector(getAppColor);
    const level = useSelector(getUserRole);

    return (
        <Grid container item xs={12} spacing={2} style={{ paddingBottom: 40 }}>
            <Grid container item xs={12}>
                <Typography className="whiteText" style={{ fontSize: 20, fontWeight: 600 }}>
                    {data.processName}
                </Typography>
            </Grid>
            <Grid container item xs={12} spacing={2}>
                <HeaderDataDisplay name={getLocalizedString("state")} value={data.status} />
                <HeaderDataDisplay
                    name={getLocalizedString("evaluationPeriodShort")}
                    value={`Del ${data.fromDate} al ${data.endDate}`}
                />
                {data.periodName && (
                    <HeaderDataDisplay name={getLocalizedString("goalEvaluationPeriod")} value={data.periodName} />
                )}
            </Grid>
            <Grid container item xs={12} justify="center">
                <Button
                    variant={"outlined"}
                    style={
                        level === "C" && data.status === "En Curso (En calibración)"
                            ? { backgroundColor: "#7D7D7D", color: "white" }
                            : { backgroundColor: color, color: "white" }
                    }
                    onClick={() => handleClick(data)}
                    disabled={level === "C" && data.status === "En Curso (En calibración)"}
                >
                    {getLocalizedString("performanceSummaryAndResults")}
                </Button>
            </Grid>
        </Grid>
    );
};

export default Row;
